<af-main-container [title]="organization?.nameRu"
                   [spinnerIds]="['initial']"
                   [tabPathToTab]="tabPathToTab"
                   [customLastBreadcrumb]="organization?.nameRu">
    @if (organization) {
        <div CustomTitle class="w-100" fxLayout="row" fxLayoutAlign="start center" fxFlex>
            <af-status class="ml-16"
                       [text]="organization.isDeleted ? 'i18n_af_statusOrganizationDeleted' : 'i18n_af_statusOrganizationActive'"
                       [style]="organization.isDeleted ? StatusStyle.ERROR : StatusStyle.SUCCESS"/>
            <div fxFlex></div>
            @if (!organization.isDeleted) {
                <ui-kit-svg class="i-24 pointer c-primary-green-900"
                            name="ic_edit"
                            [matTooltip]="'i18n_af_labelEdit' | translate"
                            (click)="editOrganization()"/>
                @if (!organization.deleteDisabled) {
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   type="secondary"
                                   buttonType="button"
                                   [label]="'i18n_af_buttonDelete' | translate"
                                   (clickListener)="deleteOrganization()"/>
                }
            } @else {
                <ui-kit-button class="ml-16"
                               type="secondary"
                               buttonType="button"
                               [label]="'i18n_af_buttonRestore' | translate"
                               (clickListener)="restoreOrganization()"/>
            }
        </div>
    }
    @if (organization?.isDeleted) {
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px"
             class="deleted-banner bc-secondary-red-100 radius-16 pt-16 pr-24 pb-16 pl-24 w-100 mt-16">
            <div class="t2-semi-bold">{{ 'i18n_af_labelOrganizationDeletedReason' | translate : {reason: deletedBaseName} }}</div>
            @if (organization.comment) {
                <div class="t4">{{ organization.comment }}</div>
            }
        </div>
    }
    @if (organization) {
        <div class="container">
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelMainInformation' | translate }}</div>
                <div class="info-container">
                    <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelBin' | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ organization.bin }}</div>
                    <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameRu' | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ organization.nameRu }}</div>
                    @if (organization.nameKz) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameKz' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.nameKz }}</div>
                    }
                    @if (organization.nameEn) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelOrganizationNameEn' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.nameEn }}</div>
                    }
                    <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelOrganizationType' | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ 'i18n_af_organizationType#' + organization.type | translate }}</div>
                    @if (organization.phone) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelOrganizationPhone' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.phone }}</div>
                    }
                    @if (organization.email) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelEmail' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.email }}</div>
                    }
                </div>
            </div>
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelSystemInformation' | translate }}</div>
                <div class="info-container">
                    <div class="t2 c-primary-gray-600">{{ 'i18n_af_column#createdDate' | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ organization.createdDate | date : 'dd.MM.yyyy' }}</div>
                    <div class="t2 c-primary-gray-600">{{ 'i18n_af_column#createdByUser' | translate }}</div>
                    <div class="t2 c-primary-gray-900">{{ organization.createdBy }}</div>
                    @if (organization.updatedDate) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelUpdatedDate' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.updatedDate | date : 'dd.MM.yyyy' }}</div>
                    }
                    @if (organization.updatedBy) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelUpdatedBy' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.updatedBy }}</div>
                    }
                    @if (organization.isDeleted) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_column#deletedDate' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.deletedDate | date : 'dd.MM.yyyy' }}</div>
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_column#deletedByUser' | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ organization.deletedBy }}</div>
                    }
                </div>
            </div>
        </div>

        <mat-tab-group mat-align-tabs="start" animationDuration="0"
                       class="tabs-container mt-8 w-100 h-100 hide-scroll-bar"
                       [(selectedIndex)]="selectedTabIndex"
                       (selectedIndexChange)="selectTab($event)">
            @for (tab of tabs; track tab) {
                <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                    <ng-template matTabContent>
                        @if (tab === 'tabOrganizationUsers') {
                            <af-full-table
                                class="w-100 h-100"
                                [filterFields]="filterFields"
                                [showFilter]="true"
                                [hasFilterContent]="!organization.isDeleted"
                                [dataSource]="usersDataSource"
                                [totalElements]="usersTotalElements"
                                [filterEvent]="usersTableEvent?.filter"
                                [pageEvent]="usersTableEvent?.page"
                                (tableUpdateListener)="loadUsers($event)"
                                [showImport]="false"
                                [showExport]="false"
                                emptyStateIconName="ic_empty_state_data_no_created"
                                emptyStateTitleTranslationKey="i18n_af_emptyStateTitleDataNotCreatedUsers"
                                [emptyStateButtonLabel]="organization.isDeleted ? null : 'i18n_af_buttonNewUser'"
                                (emptyStateClickListener)="createUser()"
                                placeholderContext="users">
                                <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16">
                                    <ui-kit-button [label]="'i18n_af_buttonNewUser' | translate"
                                                   [removePadding]="true"
                                                   type="text"
                                                   iconPosition="left"
                                                   size="small"
                                                   buttonType="button"
                                                   icon="ic_plus_ellipse"
                                                   (clickListener)="createUser()"/>
                                </div>
                            </af-full-table>
                        }
                        @if (tab === 'tabOrganizationDocuments') {
                            <af-full-table
                                class="w-100 h-100"
                                [filterFields]="filterFields"
                                [showFilter]="true"
                                [hasFilterContent]="!organization.isDeleted"
                                [dataSource]="documentsDataSource"
                                [totalElements]="documentsTotalElements"
                                [filterEvent]="documentsTableEvent?.filter"
                                [pageEvent]="documentsTableEvent?.page"
                                (tableUpdateListener)="loadDocuments($event)"
                                [showImport]="false"
                                [showExport]="false"
                                emptyStateIconName="ic_empty_state_data_no_created"
                                emptyStateTitleTranslationKey="i18n_af_emptyStateTitleDataNotCreatedOrganizationDocuments"
                                [emptyStateButtonLabel]="organization.isDeleted ? null : 'i18n_af_buttonAddDocument'"
                                (emptyStateClickListener)="addDocument()"
                                placeholderContext="organizationDocuments">
                                <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16">
                                    <ui-kit-button [label]="'i18n_af_buttonAddDocument' | translate"
                                                   [removePadding]="true"
                                                   type="text"
                                                   iconPosition="left"
                                                   size="small"
                                                   buttonType="button"
                                                   icon="ic_plus_ellipse"
                                                   (clickListener)="addDocument()"/>
                                </div>
                            </af-full-table>
                        }
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>
    }
</af-main-container>
